import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {truncateWords} from "../utils/format-text";
import Tooltip from "@mui/material/Tooltip";

// import favicon from "../../public/img/favicon.png";

const CustomUserName = ({user, sx, code = false}) => {
	const verified = user?.verified == 1 ? true : false;
	const badge = user?.badge == 1 ? true : false;
	const trusted = user?.trusted == 1 ? true : false;
	const FullName = (user?.first_name ?? "") + " " + (user?.last_name ?? "");
	const business_name = user?.business_name ? (user?.business_name ?? "") : "";
	const user_code = user?.user_code;
	return (
		<Box>
			<Box sx={{display: "flex", alignItems: "center", gap: 0.2, p: 0}}>
				{code ? (
					<Typography variant="body2" color="" sx={{...sx}}>
						{user_code}
					</Typography>
				) : (
					<Typography variant="body2" color="" sx={{lineHeight: "normal", fontSize: "16px", fontWeight: 700}}>
						{truncateWords(FullName === " " ? "Deactivated Account" : FullName, 50) || ""}
					</Typography>
				)}

				{verified && (
					<Tooltip
						slotProps={{
							popper: {
								modifiers: [
									{
										name: "offset",
										options: {
											offset: [0, -10],
										},
									},
								],
							},
						}}
						title="Business Verification"
						arrow
						placement="bottom">
						<svg
							// style={{
							// 	top: "-8px",
							// 	right: "-9px",
							// 	borderRadius: "100px",
							// }}
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							viewBox="0 0 24 24">
							<path
								fill="#0d6efd"
								d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
							/>
						</svg>
					</Tooltip>
				)}

				{badge && (
					<Tooltip
						slotProps={{
							popper: {
								modifiers: [
									{
										name: "offset",
										options: {
											offset: [0, -10],
										},
									},
								],
							},
						}}
						title="🌟 Star Contributor"
						arrow
						placement="bottom">
						<img src={`${process.env.PUBLIC_URL}/img/favicon.png`} width={18} style={{minWidth: "16px", maxWidth: "16px", height: "auto"}} />
					</Tooltip>
				)}

				{trusted && (
					<Tooltip
						slotProps={{
							popper: {
								modifiers: [
									{
										name: "offset",
										options: {
											offset: [0, -10],
										},
									},
								],
							},
						}}
						title="Trusted Contributor"
						arrow
						placement="bottom">
						<svg xmlns="http://www.w3.org/2000/svg" width="18px" height="20px" viewBox="0 0 24 24">
							<rect width="24" height="24" fill="none" />
							<path
								fill="#28A745"
								d="M12 13q1.45 0 2.475-1.025T15.5 9.5t-1.025-2.475T12 6T9.525 7.025T8.5 9.5t1.025 2.475T12 13m0 9q-3.65-.925-5.825-4T4 11.1V5l8-3l8 3v6.1q0 3.825-2.175 6.9T12 22m0-2.1q1.475-.475 2.613-1.487t1.987-2.288q-1.075-.55-2.238-.837T12 15t-2.363.288t-2.237.837q.85 1.275 1.988 2.288T12 19.9"
							/>
						</svg>
					</Tooltip>
				)}

				{/* <img src={favicon} alt="Favicon" /> */}
			</Box>
			{!code && (
				<Typography variant="body2" color="" sx={{lineHeight: "normal", fontSize: "13px", fontWeight: 600}}>
					{truncateWords(business_name, 50) || ""}
				</Typography>
			)}
		</Box>
	);
};

export default CustomUserName;
